import { BackrsIcon } from '@backrs_ui/common-ui';

import { SENDER_TYPE, SenderType } from '@backrs_ui/grow-ui/src/models/models';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectProfilePhoto } from '@backrs_ui/grow-ui/src/redux/user/user';

type ChatProfilePictureProps = Readonly<{
  sender: SenderType;
}>;

export const ChatProfilePicture = ({ sender }: ChatProfilePictureProps) => {
  const profilePicture = useAppSelector(selectProfilePhoto);

  if (sender === SENDER_TYPE.USER) {
    return profilePicture ? (
      <img src={profilePicture} alt="User" style={userProfilePictureStyle} />
    ) : (
      <BackrsIcon name="MyAccountLogo" alt="User" style={userProfilePictureStyle} />
    );
  }

  return <BackrsIcon name="LubavBubble" alt="Coach Lubav" style={lubavProfilePictureStyle} />;
};

const userProfilePictureStyle: React.CSSProperties = {
  width: '25px',
  height: '25px',
  marginRight: '15px',
  marginTop: '12px',
  borderRadius: '50%',
} as const;

const lubavProfilePictureStyle: React.CSSProperties = {
  width: '28px',
  height: '28px',
  marginRight: '15px',
  marginTop: '12px',
} as const;
